var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TariffZoneGroup',{ref:"tariffZoneGroup",attrs:{"type":_vm.operatorType,"transport":_vm.tarificationTransport}})}
var staticRenderFns = []

export { render, staticRenderFns }